import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../context/useFetch";
import { useAuth } from "../../context/AuthContext";
import MuiTextFieldHook from "../shares/MuiTextFieldHook";
import MuiButton from "../shares/MuiButton";

const Login = (props) => {
  const navigate = useNavigate();

  const { authDispatch } = useAuth();
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();

  const [postData, setPostData] = useState({});
  const loginApi = useFetch({
    method: "post",
    url: "dj-rest-auth/login",
    noHeader: true,
    data: postData,
    argFunc: (res) => {
      authDispatch({
        type: "LOGIN",
        token: res.access_token,
        refresh: res.refresh_token,
      });
      toast.success("ورود موفق", {
        position: toast.POSITION.TOP_CENTER,
      });
      navigate("/");
    },
    errMessage: (mess) => {
      toast.error("ورود ناموفق", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    setPostData(data);
    loginApi.reFetch(data);
  };
  return (
    <>
      <div className=" min-h-screen bg-white-100 py-8 flex flex-col justify-center sm:py-12">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mx-auto	 w-10/12 sm:w-auto	 relative py-3 sm:max-w-xl">
            <div className="absolute inset-0 bg-gradient-to-r from-myblue-100 to-myblue-100 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
            <div className="w-11/12 sm:w-auto mx-auto relative border px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
              <div className="max-w-md mx-auto">
                <div className="flex justify-center">
                  <h1 className="text-base md:text-2xl font-semibold">
                    به فروشگاه زرسان خوش آمدید.
                  </h1>
                </div>
                <div className="divide-y divide-gray-200">
                  <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                    <div className="relative">
                      <div className="mt-6">
                        <MuiTextFieldHook
                          id="outlined-basic"
                          label="نام کاربری "
                          variant="outlined"
                          size="small"
                          name="username"
                          isLTR={true}
                          control={control}
                          register={{
                            required: {
                              value: true,
                              message: "نام کاربری را وارد کنید",
                            },
                          }}
                        />
                      </div>
                    </div>

                    <div className="mt-6">
                      <MuiTextFieldHook
                        id="outlined-basic"
                        label="رمز عبور"
                        variant="outlined"
                        size="small"
                        name="password"
                        isLTR={true}
                        type="password"
                        control={control}
                        register={{
                          required: {
                            value: true,
                            message: "رمز عبور را وارد کنید",
                          },
                        }}
                      />
                    </div>
                    <div className="">
                      <MuiButton
                        variant="contained"
                        color="primary"
                        text="ورود"
                        type="submit"
                        isFullWidth={true}
                        withoutOnClick
                      />
                    </div>
                    
                    <div className="flex justify-center">
                      <a
                        className="link link-hover hover:no-underline hover:scale-105 transition-all"
                        onClick={() => navigate("/forgot-password")}
                      >
                        <span className="text-xs sm:text-base">
                          رمز عبور خود را فراموش کرده‌اید؟
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
